import flvjs from 'flv.js'
import httpClient, { getAuthToken } from '@/api/httpClient'

export const isFlvSupported = () => flvjs.isSupported()

// FLV is proxied by the API, so the request needs the same bearer token axios sends.
// isLive also covers recordings: the proxy does not support range requests, so a file streams from the start.
export function createFlvPlayer(video, relativeUrl, onError) {
  const baseUrl = httpClient.defaults.baseURL.replace(/\/$/, '')
  const player = flvjs.createPlayer(
    { type: 'flv', url: `${baseUrl}/${relativeUrl}`, isLive: true },
    { headers: { Authorization: getAuthToken() }, enableWorker: false }
  )

  player.on(flvjs.Events.ERROR, (type, detail, info) => onError(type, detail, info))
  player.attachMediaElement(video)
  player.load()

  const started = player.play()
  if (started && started.catch) {
    started.catch(() => {})
  }

  return player
}

export function destroyFlvPlayer(player) {
  if (!player) {
    return
  }

  try {
    player.pause()
    player.unload()
    player.detachMediaElement()
    player.destroy()
  } catch (e) {
    // The player may already be torn down after a fatal error.
  }
}
